module.exports = __webpack_public_path__ + "static/media/PN.df59bdb0.svg";